export interface GetAnnualReportTemplateTranslation {
    name: string;
    caption: Record<string, string>;
}
